import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-contact-form',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './contact-form.html',
  styleUrl: './contact-form.scss'
})
export class ContactForm {
  s3BaseUrl = environment.s3BaseUrl;
  // Datos del formulario
  formData = {
    nombre: '',
    apellidos: '',
    descripcion: ''
  };

  // Cards de aliados
  allies = [
    {
      id: 'inclub',
      name: 'InClub',
      logo: `${environment.s3BaseUrl}/logos/allies/INCLUB.png`
    },
    {
      id: 'inresort',
      name: 'InResort', 
      logo: `${environment.s3BaseUrl}/logos/allies/InResort.png`
    },
    {
      id: 'keola',
      name: 'Keola',
      logo: `${environment.s3BaseUrl}/logos/allies/Keola.png`
    },
    {
      id: 'ribera',
      name: 'Ribera del Río',
      logo: `${environment.s3BaseUrl}/logos/allies/Ribero_del_Rio.png`
    }
  ];

  // Método para manejar clic en cards de aliados
  onAllyClick(ally: any) {
    console.log('Aliado seleccionado:', ally.name);
  }

  // Obtener contador de caracteres
  getCharCount(): string {
    return `${this.formData.descripcion.length}/200`;
  }

  // Método para enviar formulario
  onSubmit() {
    if (this.formData.nombre && this.formData.apellidos && this.formData.descripcion) {
      console.log('Formulario enviado:', this.formData);
    } else {
      console.log('Por favor complete todos los campos');
    }
  }

  getImageUrl(path: string): string {
    return `${this.s3BaseUrl}/${path}`;
  }
}
